import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14632",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14632)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M-7 -1H23V8.99978H-7V-1Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M-7 8.99978H23V18.9995H-7V8.99978Z",
			fill: "#D80027"
		})]
	})]
});
export default SvgPol;
